/*
 Sets input invalid whenever function expression data-unique="expression" resolves to false. Returns to valid if input value changed
 */
'use strict';

class UniqueDirective {
    restrict = 'A';
    require = 'ngModel';
    scope = {
        ngModel: '&',
        isValidExpression: '&unique'
    };

    link(scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$parsers.push((viewValue) => {
            ngModelCtrl.$setValidity('unique', true);
            return viewValue;
        })

        scope.$watch(
            () => scope.isValidExpression(),
            () => ngModelCtrl.$setValidity('unique', scope.isValidExpression())
        );
    }
}

export let unique:any = () => new UniqueDirective();


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/validation/unique.directive.ts